export default function Pricing() {
  const plans = [
    { name:"Essential", price:"CHF 49", items:["Osnovna podrška","Email podrška","1 zadatak mjesečno"]},
    { name:"Premium", price:"CHF 149", items:["Prioritetna podrška","Telefon","Do 5 zadataka mjesečno"]},
    { name:"Concierge", price:"CHF 499", items:["Posvećeni asistent","24/7 podrška","Neograničeno zadataka"]}
  ];

  return (
    <section className="max-w-6xl mx-auto px-6 py-20">
      <h2 className="hdr-title text-4xl mb-6">Cijene</h2>
      <div className="grid md:grid-cols-3 gap-6">
        {plans.map((p, i)=>(
          <div key={i} className="card p-6 rounded-xl soft-shadow text-center">
            <div className="text-sm muted">{p.name}</div>
            <div className="text-3xl font-semibold my-4">{p.price}</div>
            <ul className="muted space-y-2 mb-6">
              {p.items.map((it, idx)=>(<li key={idx}>{it}</li>))}
            </ul>
            <button className="btn-accent px-6 py-2 rounded text-white">Zatraži</button>
          </div>
        ))}
      </div>
    </section>
  );
}
